import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import ProjectView from '../views/ProjectView.vue';
import LoginView from '../views/LoginView.vue';
import DashboardView from '@/views/DashboardView.vue';
//import VueRouter from 'vue-router';
//import HomeView from '../components/HelloWorld.vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: HomeView
        },
        {
          path: '/:language',
          children: [
            {
              name: 'home',
              path: '',
              component: HomeView
            },
            {
              name: 'login',
              path: 'login',
              component: LoginView
            },
            {
              name: 'dashboard',
              path: 'dashboard',
              component: DashboardView
            },
            {
              path: 'apps',
              name: 'apps-main',
              component: ProjectView,
              //redirect: '/',
              children: [
                {
                  path: 'hue',
                  name: 'project-details',
                  component: ProjectView
                }
              ]
            },
          ]
        }
        
    ]
});


export default router;